var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "apps" } },
    [
      _c("AppBreadCrumb", {
        attrs: { paths: [{ title: _vm.$t("message.getApps") }] },
      }),
      _vm._v(" "),
      _c(
        "b-container",
        { staticClass: "mt-3", attrs: { fluid: "", elavation: "0" } },
        [
          _c(
            "md-card",
            [
              _c("md-card-content", [
                _c("div", { staticClass: "align-items-start" }, [
                  _c("div", [
                    _c("h4", { staticClass: "mr-auto font-color" }, [
                      _vm._v(_vm._s(_vm.$t("message.downloadMobileApps"))),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "font-color" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("message.meetWithSupsis")) +
                          "\n                            "
                      ),
                      _c("span", { staticStyle: { "font-weight": "500" } }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("message.clickStoreIcon")) + " "
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "icon-container" }, [
                    _c(
                      "a",
                      {
                        staticClass: "links",
                        attrs: {
                          href: "https://play.google.com/store/apps/details?id=com.softcand.supsis&hl=en_ZA&gl=US",
                          target: "_blank",
                        },
                      },
                      [_c("GooglePlay")],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "links",
                        attrs: {
                          href: "https://apps.apple.com/ua/app/supsis/id1559749083",
                          target: "_blank",
                        },
                      },
                      [_c("AppleStore")],
                      1
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-container",
        { staticClass: "mt-3", attrs: { fluid: "", elavation: "0" } },
        [
          _c(
            "md-card",
            [
              _c("md-card-content", [
                _c("div", { staticClass: "align-items-start" }, [
                  _c(
                    "div",
                    { staticClass: "mr-auto" },
                    [
                      _c("div", [
                        _c("h4", { staticClass: "font-color" }, [
                          _vm._v(_vm._s(_vm.$t("message.weLlSendPhone"))),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "font-color" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.offerlinkSendToPhone"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "md-field",
                        [
                          _c("label", { staticClass: "font-color" }, [
                            _vm._v(_vm._s(_vm.$t("message.phone"))),
                          ]),
                          _vm._v(" "),
                          _c("md-input", {
                            directives: [
                              {
                                name: "mask",
                                rawName: "v-mask",
                                value: "(###) ### ## ##",
                                expression: "'(###) ### ## ##'",
                              },
                            ],
                            staticClass: "font-color",
                            attrs: {
                              label: _vm.$t("message.phone"),
                              autocomplete: "off",
                              trim: "",
                              type: "tel",
                            },
                            model: {
                              value: _vm.phone,
                              callback: function ($$v) {
                                _vm.phone = $$v
                              },
                              expression: "phone",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-button",
                        {
                          staticClass:
                            "font-color md-dense md-raised md-primary m-0",
                          attrs: { disabled: _vm.phone.length < 15 },
                          on: { click: _vm.send },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("message.send")) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-container",
        { staticClass: "mt-3", attrs: { fluid: "", elavation: "0" } },
        [
          _c(
            "md-card",
            [
              _c("md-card-content", [
                _c("div", { staticClass: "align-items-start" }, [
                  _c(
                    "div",
                    { staticClass: "mr-auto" },
                    [
                      _c("div", [
                        _c("h4", { staticClass: "font-color" }, [
                          _vm._v(_vm._s(_vm.$t("message.weLlSendEmail"))),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "font-color" }, [
                          _vm._v(_vm._s(_vm.$t("message.offerlinkSendToMail"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "md-radio",
                            {
                              attrs: { value: "accent" },
                              on: { change: _vm.radioControl },
                              model: {
                                value: _vm.radio,
                                callback: function ($$v) {
                                  _vm.radio = $$v
                                },
                                expression: "radio",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("message.theEmail")) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "md-radio",
                            {
                              staticClass: "md-primary",
                              attrs: { value: "Primary" },
                              model: {
                                value: _vm.radio,
                                callback: function ($$v) {
                                  _vm.radio = $$v
                                },
                                expression: "radio",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("message.differentEmail")) +
                                  "\n                            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-field",
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("message.email"))),
                          ]),
                          _vm._v(" "),
                          _c("md-input", {
                            staticClass: "font-color",
                            attrs: {
                              label: _vm.$t("message.email"),
                              autocomplete: "off",
                              trim: "",
                              type: "tel",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.isEmailValid()
                              },
                            },
                            model: {
                              value: _vm.email,
                              callback: function ($$v) {
                                _vm.email = $$v
                              },
                              expression: "email",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-button",
                        {
                          staticClass:
                            "font-color md-dense md-raised md-primary m-0",
                          attrs: {
                            disabled: this.validMail === "classs-error",
                          },
                          on: { click: _vm.send },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.isEmailValid()) +
                              _vm._s(_vm.$t("message.send")) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isAdmin ? _c("ChatBar", { attrs: { visible: false } }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }